import React, { useState, useRef, useEffect } from 'react';
import './Experience.css';
import byjus from '../assets/byjus.png';
import capitalflo from '../assets/capitalflo.png';
import swarajya from '../assets/swarajya.png';
import hapzea from '../assets/hapzea.png';

function Experience() {
  const [tooltip, setTooltip] = useState({ text: '', position: { x: 0, y: 0 }, visible: false });
  const expRef = useRef(null); // Reference to the Experience section
  const [isVisible, setIsVisible] = useState(false); // State to track visibility

  const handleMouseEnter = (text, e) => {
    const { clientX: x, clientY: y } = e;
    setTooltip({ text, position: { x, y }, visible: true });
  };

  const handleMouseLeave = () => {
    setTooltip({ ...tooltip, visible: false });
  };

  useEffect(() => {
    const observerOptions = {
      root: null, // Observe relative to the viewport
      rootMargin: '0px',
      threshold: 0.1, // Trigger when 10% of the section is visible
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    if (expRef.current) {
      observer.observe(expRef.current);
    }

    // Cleanup observer on unmount
    return () => {
      if (expRef.current) {
        observer.unobserve(expRef.current);
      }
    };
  }, []);

  return (
    <div className={`exp-page ${isVisible ? 'visible' : ''}`} ref={expRef}>
      <p>Professional Journey <span>.</span></p>
      <div className="exp-journey">
        <div className="exp-item" 
          onMouseEnter={(e) => handleMouseEnter('Byjus - Edtech Company\nYears of Service: 2015 - 2018\nRole: BDA', e)} 
          onMouseLeave={handleMouseLeave}>
          <img src={byjus} alt="byjus" className="company_logo1" />
        </div>
        <div className="arrow">→</div>
        <div className="exp-item" 
          onMouseEnter={(e) => handleMouseEnter('Swarajya - Media Platform\nYears of Service: 2020 - 2022\nRole: Senior Developer', e)} 
          onMouseLeave={handleMouseLeave}>
          <img src={swarajya} alt="swarajya" className="company_logo3" />
        </div>
        <div className="arrow">→</div>
        <div className="exp-item" 
          onMouseEnter={(e) => handleMouseEnter('Capitalflo - Fintech Platform\nYears of Service: 2018 - 2020\nRole: Full-Stack Developer', e)} 
          onMouseLeave={handleMouseLeave}>
          <img src={capitalflo} alt="capitalflo" className="company_logo2" />
        </div>
        <div className="arrow">→</div>
        <div className="exp-item" 
          onMouseEnter={(e) => handleMouseEnter('Hapzea - Social App\nYears of Service: 2022 - Present\nRole: Lead Engineer', e)} 
          onMouseLeave={handleMouseLeave}>
          <img src={hapzea} alt="hapzea" className="company_logo4" />
        </div>
      </div>
      {tooltip.visible && (
        <div
          className="tooltip"
          style={{
            left: tooltip.position.x + 10,
            top: tooltip.position.y + 10
          }}
        >
          {tooltip.text.split('\n').map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      )}
    </div>
  );
}

export default Experience;
